import { render, staticRenderFns } from "./caseList.vue?vue&type=template&id=3869601f&scoped=true"
import script from "./caseList.vue?vue&type=script&lang=js"
export * from "./caseList.vue?vue&type=script&lang=js"
import style0 from "./caseList.vue?vue&type=style&index=0&id=3869601f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3869601f",
  null
  
)

export default component.exports